<script setup lang="ts">
  import { TravelDirection } from '@/shared/types/common.types'
  import { FlowQuoteWidgetQC } from '@/widgets/Flow'
</script>

<template>
  <FlowQuoteWidgetQC :type-of-travel="TravelDirection.INBOUND" />
</template>
